import { Injectable, resource, signal } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { DriftsMeddelelseSearchParams } from './driftsmeddelelse-search-params';
import { DriftsMeddelelse } from './driftsmeddelelse.model';

@Injectable({
  providedIn: 'root',
})
export class DriftsMeddelelserDatasource extends RestDatasource<DriftsMeddelelse> {
  override endpoint = '/api/admin/driftsmeddelelser';

  searchParams = signal<DriftsMeddelelseSearchParams>({});

  override data = resource({
    params: () => this.searchParams(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify(params),
          sortBy: 'start',
          descending: true,
        },
        abortSignal
      );
    },
  });

  reloadDatasource() {
    this.searchParams.update(x => ({ ...x, searchTime: new Date() }));
  }
}
